import { render, staticRenderFns } from "./CenterFaqPage.vue?vue&type=template&id=5e208816&"
import script from "./CenterFaqPage.vue?vue&type=script&lang=js&"
export * from "./CenterFaqPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports